export default __webpack_public_path__ + "static/media/Hands_Orange.f7b464a6.png";